import { LineItem } from 'line-item';
import { Shelf } from 'shelf';
import { Constants } from 'utils';
class ShelfConfigurator extends HTMLElement {
	connectedCallback() {
		this.levels = [];
		this.lineItems = [];
		this.placements = [];
		this.success = false;
		this.freeSpaces = [];
		this.isShelfReady = false;
		this.bufferSpace = parseFloat(this.dataset.shelfBufferSpace) * 10 || 1;
		this.lidOffset = parseFloat(this.dataset.shelfLidOffset) * 10 || 4;
		this.view = 'FRONT';
		this.shelfForm = this.querySelector('shelf-form');
		this.orderForm = this.querySelector('order-form');
		this.shelfOutput = document.querySelector('shelf-sticky-bar');
		this.resetOrderButton = this.querySelector('[reset-order]');
		this.resetShelfSizesButtons = this.querySelectorAll('[reset-shelf-sizes]');
		this.shelfVisualization = this.querySelector('shelf-visualization');
		this.visualizationViewButtons = this.shelfVisualization.querySelectorAll('button[view]');
		this.shelfForm.addEventListener('shelf-form:set-up', this.onShelfReady.bind(this));
		this.orderForm.addEventListener('order-form:change', this.onOrderFormChange.bind(this));
		this.orderForm.addEventListener('order-form:randomize', this.onRandomFill.bind(this));
		this.resetOrderButton.addEventListener('click', this.onOrderFormReset.bind(this));
		this.resetShelfSizesButtons.forEach((button) => {
			button.addEventListener('click', this.onShelfFormReset.bind(this));
		});
		this.visualizationViewButtons.forEach((button) => {
			button.addEventListener('click', this.onVisualizationViewChange.bind(this));
		});
		// TODO: remove this when not needed
		setTimeout(() => {
			this.initInfoModals();
			this.loadLocalStorage();
		}, 1000);
	}
	disconnectedCallback() {
		this.shelfForm.removeEventListener('shelf-form:set-up', this.onShelfReady.bind(this));
		// TODO: Remove other event listeners
	}
	generateUrlParams() {
		const shelfData = {
			levels: this.levels,
			isShelfReady: this.isShelfReady,
			lineItems: this.lineItems.map((lineItem) => ({
				variantID: lineItem.variantID,
				quantity: lineItem.quantity,
				color: lineItem.color,
				width: lineItem.width,
				height: lineItem.height,
				depth: lineItem.depth,
				imageUrl: lineItem.imageUrl,
			})),
		};
		const jsonString = JSON.stringify(shelfData);
		const searchParams = new URLSearchParams();
		searchParams.set('shelf', jsonString);
		return searchParams;
	}
	initInfoModals() {
		const infoButtons = this.querySelectorAll('[data-modal-id]');
		infoButtons.forEach((button) => {
			const modalId = button.getAttribute('data-modal-id');
			const modalName = button.getAttribute('data-modal-name');
			const modal = new theme.Modals(modalId, modalName, {
				bodyOpenClass: ['modal-open', 'modal-open--shelf-configurator'],
			});
			document.addEventListener('modalOpen.' + modalId, () => {
				this.shelfOutput.hide();
			});
			document.addEventListener('modalClose.' + modalId, () => {
				this.shelfOutput.show();
			});
		});
	}
	updateLocalStorage() {
		// TODO: minimize the data stored in localStorage
		const shelfData = {
			levels: this.levels,
			isShelfReady: this.isShelfReady,
			lineItems: this.lineItems.map((lineItem) => ({
				variantID: lineItem.variantID,
				quantity: lineItem.quantity,
				color: lineItem.color,
				width: lineItem.width,
				height: lineItem.height,
				depth: lineItem.depth,
				imageUrl: lineItem.imageUrl,
			})),
		};
		// this.generateUrlParams();
		localStorage.setItem('shelfConfiguratorData', JSON.stringify(shelfData));
	}
	loadLocalStorage() {
		const url = new URL(window.location.href);
		const params = url.searchParams;
		const shelfParam = params.get('shelf');
		// remove the shelf parameter from the URL
		if (params.has('shelf')) {
			params.delete('shelf');
			const newUrl = params.toString() ? `${url.pathname}?${params.toString()}` : url.pathname;
			window.history.replaceState({}, '', newUrl);
		}
		const shelfDataFromParam = shelfParam ? decodeURIComponent(shelfParam) : null;
		const shelfData = shelfDataFromParam || localStorage.getItem('shelfConfiguratorData');
		if (shelfData) {
			try {
				const { levels, isShelfReady, lineItems } = JSON.parse(shelfData);
				// TODO: Add variable isShelfReady to this class
				if (!Array.isArray(levels) || !Array.isArray(lineItems)) {
					throw new Error('Invalid data format in localStorage');
				}
				levels.length > 0 && this.shelfForm.initWithLocalStorage({ levels, isShelfReady: isShelfReady });
				this.levels = levels;
				this.isShelfReady = isShelfReady;

				if (lineItems.length > 0) {
					this.orderForm.initWithLocalStorage({ lineItems });
					this.onOrderFormChange({
						detail: { lineItems: lineItems },
					});
				}
			} catch (error) {
				console.error('Error parsing shelfConfiguratorData from localStorage:', error);
				localStorage.removeItem('shelfConfiguratorData');
			}
		}
	}

	onOrderFormChange(event) {
		// TODO: MOVE TO ONE FUNCTION
		// TODO: on RESET THIS IS CALLED Ax the amount of line items
		this.lineItems = event.detail.lineItems;
		this.initLineItemsObjects();
		this.initImageUrls();
		this.calculatePositions();
		const isShelfFull = this.orderForm.isShelfFull(this.shelf);
		this.shelfVisualization.rerender({
			view: this.view,
			shelf: this.shelf,
			placements: this.placements,
			imageMap: this.imageMap,
		});
		// TODO: REFACTOR THIS
		const fitItemsMap = {};
		this.placements.forEach((placement) => {
			fitItemsMap[placement.variantID] = fitItemsMap[placement.variantID] ? fitItemsMap[placement.variantID] + 1 : 1;
		});
		const fitItems = Object.entries(fitItemsMap).map(([variantID, count]) => ({ variantID, count }));

		this.shelfOutput?.initializeLineItems(fitItems, isShelfFull);
		this.updateLocalStorage();
	}
	onRandomFill(event) {
		if (!this.shelf || !this.orderForm) return;
		const selectedCategory = event.detail?.category || Constants.AUTO_FILLER_ALL;
		const candidates = (this.orderForm.lineItems || [])
			.filter((lineItem) => selectedCategory === Constants.AUTO_FILLER_ALL || lineItem.category === selectedCategory)
			.map((lineItem) => ({
				...lineItem,
				quantity: 0,
				variantID: String(lineItem.variantID),
			}));
		const lineItems = this.shelf.fillShelfRandomly(candidates, {
			maxSteps: 2000,
			rng: Math.random,
			maxBudget: event.detail?.maxBudget || Infinity,
		});
		this.orderForm.initWithLocalStorage({ lineItems });
		this.onOrderFormChange({ detail: { lineItems } });
		setTimeout(() => {
			this.shelfVisualization.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}, 200);
		this.updateLocalStorage();
	}

	onOrderFormReset() {
		this.orderForm.reset();
		this.updateLocalStorage();
	}
	onShelfReady(event) {
		const { levels } = event.detail;
		const didShelfChanged =
			JSON.stringify(this.levels.sort((levelA, levelB) => levelA.index - levelB.index)) !==
			JSON.stringify(levels.sort((levelA, levelB) => levelA.index - levelB.index));
		this.levels = levels;

		this.initShelfObject();
		this.shelfForm.classList.add('hide');
		const atLeastOneCouldFit = this.orderForm.setDimensions({
			maxWidth: this.shelf.maxWidth,
			maxHeight: this.shelf.maxHeight,
			maxDepth: this.shelf.maxDepth,
			bufferSpace: this.shelf.bufferSpace,
			bins: this.shelf.bins,
		});
		this.classList.toggle('shelf-configurator--order-form-empty', !atLeastOneCouldFit);
		this.orderForm.updateLineItemInputs(this.shelf);
		this.orderForm.classList.remove('hide');
		this.shelfVisualization.classList.remove('hide');
		this.shelfVisualization.rerender({
			view: this.view,
			shelf: this.shelf,
			placements: this.placements,
			imageMap: this.imageMap,
		});
		if (didShelfChanged) {
			this.orderForm.reset();
		}
		this.shelfOutput?.show();
		this.isShelfReady = true;
		this.updateLocalStorage();
	}
	onShelfFormReset() {
		this.shelfForm.classList.remove('hide');
		this.orderForm.classList.add('hide');
		this.shelfVisualization.classList.add('hide');
		this.shelfOutput?.hide();
		setTimeout(() => {
			this.shelfForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}, 200);
		this.isShelfReady = false;
		this.updateLocalStorage();
	}
	initShelfObject() {
		if (this.levels.length === 0) {
			console.error('No levels defined in shelf form');
			return;
		}
		this.shelf = new Shelf({ ...this.levels[0], bufferSpace: this.bufferSpace, lidOffset: this.lidOffset });
		this.levels.slice(1).forEach((level) => {
			this.shelf.addBin({
				width: level.width,
				height: level.height,
				depth: level.depth,
				binPlacement: level.levelPlacement,
			});
		});
	}
	initLineItemsObjects() {
		this.lineItemsObjects = this.lineItems.map((lineItem) => {
			return new LineItem({
				...lineItem,
				position: {
					x: 0,
					y: 0,
					z: 0,
				},
			});
		});
	}
	initImageUrls() {
		//TODO: handed as color to the line item
		this.imageMap = {};
		this.lineItems.forEach((lineItem) => {
			if (lineItem.imageUrl) {
				this.imageMap[lineItem.variantID] = lineItem.imageUrl;
			}
		});
	}
	onVisualizationViewChange(event) {
		const view = event.target.getAttribute('view');
		this.view = view;
		this.visualizationViewButtons.forEach((button) => {
			button.classList.remove('button--primary');
			button.classList.add('button--secondary');
		});
		event.target.classList.remove('button--secondary');
		event.target.classList.add('button--primary');
		this.shelfVisualization.rerender({
			view,
			shelf: this.shelf,
			placements: this.placements,
			imageMap: this.imageMap,
		});

		this.updateLocalStorage();
	}
	calculatePositions() {
		const result = this.shelf.doesLineItemsFit(this.lineItemsObjects);
		this.placements = result.placements;
		this.success = result.success;
		this.freeSpaces = result.freeSpaces;
		// used to disable the button if no items can fit anymore
		this.orderForm.updateLineItemInputs(this.shelf);
		return result.success;
	}
}
customElements.define('shelf-configurator', ShelfConfigurator);
